import { TabConfig } from "@/dentlab/src/types/tab-config.types";

export const SYSTEM_DEFAULT_TAB_CONFIG: TabConfig[] = [
	{
		id: "0",
		icon: "Files",
		type: "files",
		color: "#eab308",
		order: 0,
		isDefaultActive: true,
	},
	{
		id: "1",
		icon: "User",
		type: "general",
		color: "#10b981",
		label: "Patient",
		order: 1,
		columns: 2,
		rows: 3,
		fields: [
			{
				fieldId: "patient_select",
				required: false,
				col: 0,
				row: 0,
				colSpan: 1,
			},
			{
				fieldId: "patients.title",
				required: false,
				col: 1,
				row: 0,
				colSpan: 1,
			},
			{
				fieldId: "patients.first_name",
				required: false,
				useInTitle: true,
				col: 0,
				row: 1,
				colSpan: 1,
			},
			{
				fieldId: "patients.last_name",
				required: false,
				useInTitle: true,
				col: 1,
				row: 1,
				colSpan: 1,
			},
			{
				fieldId: "patients.code",
				required: false,
				useInTitle: true,
				col: 0,
				row: 2,
				colSpan: 1,
			},
			{
				fieldId: "patients.birth_date",
				required: false,
				useInTitle: true,
				col: 1,
				row: 2,
				colSpan: 1,
			},
		],
		isDefaultActive: true,
	},
	{
		id: "2",
		icon: "FileText",
		type: "general",
		color: "#3b82f6",
		label: "Auftrag",
		order: 2,
		columns: 3,
		rows: 4,
		fields: [
			{
				fieldId: "jobs.price_list_id",
				required: false,
				col: 0,
				row: 0,
				colSpan: 1,
			},
			{
				fieldId: "practitioner_select",
				required: false,
				useInTitle: false,
				col: 1,
				row: 0,
				colSpan: 1,
			},
			{
				fieldId: "jobs.incoming_order_datetime",
				required: false,
				col: 2,
				row: 0,
				colSpan: 1,
			},
			{
				fieldId: "jobs.tp_value",
				required: false,
				col: 0,
				row: 1,
				colSpan: 1,
			},
			{
				fieldId: "jobs.tooth_color",
				required: false,
				useInTitle: true,
				col: 1,
				row: 1,
				colSpan: 1,
			},
			{
				fieldId: "jobs.outgoing_order_datetime",
				required: false,
				col: 2,
				row: 1,
				colSpan: 1,
			},
			{
				fieldId: "jobs.description",
				required: false,
				useInTitle: true,
				col: 0,
				row: 2,
				colSpan: 3,
			},
		],
		isDefaultActive: true,
	},
	{
		id: "3",
		icon: "Sigma",
		type: "total",
		color: "#689689",
		order: 3,
		isDefaultActive: true,
	},
	{
		id: "4",
		icon: "DollarSign",
		type: "general",
		color: "#dc2626",
		label: "Patient zahlt selbst",
		order: 4,
		columns: 2,
		rows: 3,
		fields: [
			{
				fieldId: "patients.street",
				required: false,
				col: 0,
				row: 0,
				colSpan: 1,
			},
			{
				fieldId: "patients.additional_information",
				required: false,
				col: 1,
				row: 0,
				colSpan: 1,
			},
			{
				fieldId: "patients.city_postal_code_country",
				required: false,
				col: 0,
				row: 1,
				colSpan: 2,
			},
			{
				fieldId: "jobs.is_paid_by_patient",
				required: false,
				col: 0,
				row: 2,
				colSpan: 2,
			},
		],
		isDefaultActive: false,
	},
	{
		id: "5",
		icon: "Truck",
		type: "deliveries",
		color: "#8b5cf6",
		order: 5,
		isDefaultActive: false,
	},
	{
		id: "6",
		icon: "StickyNote",
		type: "notes",
		color: "#F9FAFB",
		order: 6,
		isDefaultActive: false,
	},
	{
		id: "7",
		icon: "History",
		type: "job_history",
		color: "#F9FAFB",
		order: 7,
		isDefaultActive: false,
	},
];
